import { styled } from '@mui/material';

import { Drawer } from '@/components/Layout/Drawer';

import { doNotForwardTheseProps } from '@/styles';

import {
  PreQuestionsContainer,
  QuestionItem,
} from '../components/components.styled';

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  '.DrawerContent': {
    minHeight: 'unset',
    paddingTop: theme.spacing(10),
    justifyContent: 'flex-end',
    paddingBottom: theme.spacing(6),
  },

  [theme.breakpoints.up('lg')]: {
    '.DrawerContent': {
      justifyContent: 'flex-start',
    },
  },
}));

export const RequiredDocumentsCard = styled(PreQuestionsContainer)(
  ({ theme }) => ({
    marginTop: theme.spacing(2),
  }),
);
export const RequiredDocumentItemContainer = styled(QuestionItem, {
  shouldForwardProp: doNotForwardTheseProps('isFaded'),
})<{ isFaded?: boolean }>(({ theme, isFaded }) => ({
  opacity: isFaded ? 0.2 : 1,

  '.MuiListItemIcon-root:first-of-type': {
    marginRight: theme.spacing(1.5),
  },
}));
